module.exports = {"searchMenu":"搜索菜单","recentSearch":"最近搜索","searchResultCount":"{count}条搜索结果","noData":"暂无数据","searchShortcut":"搜索({shortcut})"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/header.json
// module id = REa4
// module chunks = 1